import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cf108fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-sm flex items-center" }
const _hoisted_2 = { class: "border rounded px-1 text-course border-course dark:text-course-dark dark:border-course-dark" }
const _hoisted_3 = { class: "ml-3 text-gray-800 dark:text-dark-text" }
const _hoisted_4 = { class: "text-base font-bold mt-2 text-gray-800 dark:text-dark-text" }
const _hoisted_5 = { class: "w-5/6 text-xs flex items-center text-gray-600 dark:text-dark-text" }
const _hoisted_6 = { class: "m-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_progress_bar = _resolveComponent("base-progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: "hover-hand border rounded p-4 w-full hover:shadow-lg transition-shadow duration-200 hover:border-course text-gray-900 dark:border-dark-400 dark:text-dark-text dark:bg-dark-500 dark:hover:border-course-dark",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.course.type), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.course.shortName), 1)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.course.name), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.calc2digit(_ctx.course.progress)) + "%", 1),
      _createVNode(_component_base_progress_bar, {
        num: _ctx.calc2digit(_ctx.course.progress)
      }, null, 8, ["num"])
    ])
  ]))
}